import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    HostBinding,
    Input,
    ViewEncapsulation,
} from '@angular/core';
import { IItemsListAction2 } from '@fi-shared/fi-items-list/fi-items-list';
import { isDefined } from '@fi-shared/utils';
import { FiInfoIconMode } from '@fi-shared/info-icon/info-icon.component';

@Component({
    selector: 'fi-mat-icon-checkbox-menu',
    template: `
        <button
            mat-icon-button
            type="button"
            [class]="menuTriggerClass"
            (click)="$event.stopPropagation()"
            [matMenuTriggerFor]="matIconCheckboxMenu"
            [disabled]="isDisabled"
        >
            <mat-icon [class]="buttonIconClass"></mat-icon>
        </button>

        <mat-menu #matIconCheckboxMenu [class]="getMatMenuClasses()">
            @for (action of actions; track action) {
                @if (isMatMenuItemShown(action)) {
                    <fi-mat-icon-checkbox-menu-item [value]="value" [menuClass]="'fi-rounded-menu ' + subMenuClass" [action]="action">
                    </fi-mat-icon-checkbox-menu-item>
                }
            }
        </mat-menu>
    `,
    styleUrls: ['./fi-mat-icon-checkbox-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-mat-icon-checkbox-menu' },
    standalone: false,
})
export class FiMatIconCheckboxMenuComponent<T> {
    @Input() value: T;
    @Input() menuTriggerClass: string;
    @Input() buttonIconClass: string;
    @Input() actions: IItemsListAction2<T>[];
    @Input() matMenuClass: string;
    @Input() subMenuClass: string;
    @Input() isDisabled: boolean;

    @HostBinding('attr.hidden')
    get hidden(): boolean {
        return this.actions.filter((action: IItemsListAction2<T>) => this.isMatMenuItemShown(action)).length
            ? undefined
            : true;
    }

    protected isMatMenuItemShown(action: IItemsListAction2): boolean {
        return isDefined(action.condition) ? action.condition(this.value) : true;
    }

    constructor(private cdr: ChangeDetectorRef) {}

    detectChanges() {
        this.cdr.detectChanges();
    }

    getMatMenuClasses(): string {
        return `${this.matMenuClass} fi-rounded-menu fi-custom-mat-menu`;
    }

    protected readonly FiInfoIconMode = FiInfoIconMode;
}
